import { Flex, Text, CalendarTodayOutlinedIcon } from '@shared/components';

export type ExamEventScheduleEmptyStateVariant =
  | 'scheduled'
  | 'ready-to-exam'
  | 'in-progress'
  | 'completed'
  | 'canceled';

interface ExamEventScheduleEmptyStateProps {
  variant?: ExamEventScheduleEmptyStateVariant;
}

const VARIANTS_LABEL: Record<ExamEventScheduleEmptyStateVariant, string> = {
  scheduled: 'ยังไม่มีการกำหนดรอบการสอบ',
  'ready-to-exam': 'ยังไม่มีรอบสอบที่เตรียมพร้อมสอบ',
  'in-progress': 'ยังไม่มีรอบสอบที่กำลังสอบ',
  completed: 'ยังไม่มีรอบสอบที่เสร็จสิ้น',
  canceled: 'ยังไม่มีรอบสอบที่ยกเลิก',
};

export default function ExamEventScheduleEmptyState(
  props: Readonly<ExamEventScheduleEmptyStateProps>,
) {
  const { variant = 'scheduled' } = props;

  return (
    <Flex
      sx={(theme) => ({
        height: '142px',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.palette.grey[50],
        border: '1px dashed',
        borderColor: theme.palette.grey[300],
        borderRadius: theme.shape.rounded(2),
        gap: theme.spacing(4),
      })}
    >
      <CalendarTodayOutlinedIcon
        sx={{
          color: (theme) => theme.palette.grey[400],
          fontSize: '48px',
        }}
      />

      <Text variant='h4' sx={{ textAlign: 'center' }}>
        {VARIANTS_LABEL[variant]}
      </Text>
    </Flex>
  );
}
